import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import css from './DoorbellButton.css';
import StyledButton from 'common/StyledButton';
import Icon from 'SF/MaterialIcon';
import ReactTooltip from 'react-tooltip';
import { useLocalStorage } from 'react-use';
import { isEmpty, difference } from 'lodash';

const DoorbellButton = ({studentsResponseData}) => {
  const [isToggled, setIsToggled] = useLocalStorage('wr-sound-control', true);
  const audioRef = useRef(null);
  const lastStudentResponse = useRef({});
  
  const onClick = () => {
    setIsToggled(!isToggled);
    ReactTooltip.hide();
  };

  useEffect(() => {
    if ( isEmpty(studentsResponseData) ) return;

    // If the doorbell toggle is on and we had at least two responses, we can compare
    // them and check if there is any new student. If that's the case, we play the doorbell
    if ( isToggled && !isEmpty(lastStudentResponse.current) ) {
      const appointmentsWaiting = studentsResponseData.results
        .filter(({status}) => status === "WAITING")
        .map(({id}) => id);
  
      const lastAppointmentsWaiting = lastStudentResponse.current.results
        .filter(({status}) => status === "WAITING")
        .map(({id}) => id);
  
      // We check if there is any new appointment here
      const newAppointments = difference(appointmentsWaiting, lastAppointmentsWaiting);
  
      if ( newAppointments.length > 0 ) audioRef.current.play();
    }

    // Update the last response in order to compare next time
    lastStudentResponse.current = studentsResponseData;

  }, [studentsResponseData]);
  
  return (
    <div className={css['doorbell-container']}>
      <StyledButton asLink onClick={onClick}>
        <Icon 
          icon={`volume_${isToggled ? 'up' : 'off'}`} 
          style={{color: isToggled ? "#1E70A6" : "#57595B"}}
          data-tip={`Click to turn sound <br> notification ${isToggled ? 'off' : 'on'}.`}
          aria-label={`Click to turn sound notification ${isToggled ? 'off' : 'on'}.`}
        />
      </StyledButton>
      <audio id="wr-doorbell" preload="auto" ref={audioRef}>
        <source src="../audio/DoorBell.mp3" />
        <source src="../audio/DoorBell.ogg" />
        <source src="../audio/DoorBell.wav" />
      </audio>
      <ReactTooltip
        className={css['tooltip']}
        multiline
        effect="solid"
        place="bottom"
      />     
    </div>
  );
}

DoorbellButton.propTypes = {
  studentsResponseData: PropTypes.object.isRequired,
};

export default DoorbellButton;
